// st-dialog moves its card onto the app overlay, outside the component root.
// The inner v-dialog keeps that moved node on $refs.content.
function dialogContentElement (shell) {
  if (!shell || !shell.$children || !shell.$children[0]) return null
  const refs = shell.$children[0].$refs
  if (!refs) return null
  return refs.content || null
}

function queryHeight (content, selector, fallback) {
  if (!content || typeof content.querySelector !== 'function') return fallback
  const element = content.querySelector(selector)
  if (!element || !element.clientHeight) return fallback
  return element.clientHeight
}

module.exports = {
  dialogContentElement: dialogContentElement,
  queryHeight: queryHeight
}
